import { mdiEyeOff } from '@mdi/js';
import { Icon } from '@mdi/react';
import React from 'react';
import { Tooltip } from '../base/tooltip';
import * as S from './unread-button.styles';

interface IUnreadButtonProps {
    count?: number;
    disabled?: boolean;
    onClick: () => void;
}
export const UnreadButton: React.FunctionComponent<IUnreadButtonProps> = (
    props: IUnreadButtonProps,
): React.ReactElement => {
    const { count, disabled, onClick } = props;
    const message = count ? `Mark ${count} messages as Unread` : 'Mark as Unread';
    return (
        <Tooltip direction="top" title={<span>{message}</span>}>
            <S.UnreadButton variant="outlined" onClick={onClick} disabled={disabled}>
                <Icon path={mdiEyeOff} size={1} />
            </S.UnreadButton>
        </Tooltip>
    );
};
